import { SaleBadgeProps } from '../../types';
import { generateSalePercentageBasedOnType } from 'utils';
import { ESaleDiscountDisplayType } from 'utils/enums';
import { StyledMightyFuSaleBadge } from './style';

export const MightyFuSaleBadge = ({
  salePercentage,
  salePercentageDisplayType = ESaleDiscountDisplayType.PERCENTAGE,
}: SaleBadgeProps) => {
  return (
    <StyledMightyFuSaleBadge className="mighty-fu-sale-badge">
      {generateSalePercentageBasedOnType(
        salePercentage,
        salePercentageDisplayType,
      )}{' '}
      MORE
    </StyledMightyFuSaleBadge>
  );
};
